import { biLogger } from '../biLogger';
import { locale } from '../constants';
import { selectAttachmentsBiData, selectBiData } from '../selectors';
import { BiEventLogger, ChatbotSendMessageBiData } from '../types';
import { getRuntimeDataForBi } from '../utils';

export const logChatbotSendMessage: BiEventLogger<ChatbotSendMessageBiData> = async (state, data) => {
  const biData = selectBiData(state);
  const { attachmentsLength, attachments, attachingMethod } = selectAttachmentsBiData(state);
  const { sessionId, contextBi } = await getRuntimeDataForBi(state);

  biLogger.chatbotSendMessage({
    attached_files: JSON.stringify(attachments),
    attaching_method: JSON.stringify(attachingMethod),
    number_of_files: attachmentsLength,
    node_id: biData.nodeId,
    conversation_id: biData.conversationId,
    intent_id: biData.intentId,
    main_option_name: biData.mainOptionName,
    session_id: sessionId,
    context_platform: contextBi?.context_platform,
    context_area: contextBi?.context_area,
    context_parenturl: contextBi?.context_parenturl,
    context_page_urlchunks: contextBi?.context_page_urlchunks,
    context_uuid: contextBi?.context_uuid,
    context_domain: contextBi?.context_domain,
    context_page_queryparams: contextBi?.context_page_queryparams,
    context_iframeurllist: contextBi?.context_iframeurllist,
    context_msid: contextBi?.context_msid,
    context_page_numlevels: contextBi?.context_page_numlevels,
    context_page_toplevelroute: contextBi?.context_page_toplevelroute,
    mapping_product: contextBi?.mapping_product,
    mapping_url: contextBi?.mapping_url,
    user_experience: contextBi?.user_experience,
    lang: locale,
    chatbot_view: contextBi?.chatbot_view,
    button_id: biData.buttonId,
    send_action_type: data.sendActionType,
    ab_test_version: undefined,
    main_option_id: undefined,
    user_intent: undefined,
    ai_user_intent: undefined,
    ai_user_intent_type: undefined,
    node_type_id: undefined,
    node_type: undefined,
    node_name: undefined,
  });
};
